'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const theme_LegacyTypography = require('../../../theme/LegacyTypography.cjs.js');
require('react');
const theme_LegacyColorMap = require('../../../theme/LegacyColorMap.cjs.js');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_display_Tag_Tag = require('../../display/Tag/Tag.cjs.js');
const components_layout_Grid_Grid = require('../../layout/Grid/Grid.cjs.js');
const components_navigation_Button_Button = require('../../navigation/Button/Button.cjs.js');
const components_navigation_Link_Link = require('../../navigation/Link/Link.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');
const components_display_Heading_Heading = require('../../display/Heading/Heading.cjs.js');
const components_display_Heading_HeadingLevel = require('../../display/Heading/HeadingLevel.cjs.js');

const Styles = styleEncapsulation.labelStyles("TwoColumnRiver", {
  root: (backgroundColor = "neutral100") => react.css`
    ${styleMixins_reset.boxSizing};
    background-color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[backgroundColor]]};
    padding: 20px;

    @media screen and (min-width: 640px) {
      padding: 40px 30px;
    }

    @media screen and (min-width: 1024px) {
      padding: 60px 20px;
    }
  `,
  container: (isReversed) => react.css`
    ${styleMixins_reset.boxSizing};
    max-width: 1170px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column-reverse;

    @media screen and (min-width: 1024px) {
      flex-direction: ${isReversed ? "row-reverse" : "row"};
    }
  `,
  content: react.css`
    ${styleMixins_reset.boxSizing};
    width: 100%;

    @media screen and (min-width: 1024px) {
      max-width: 500px;
      padding-right: 30px;
    }
  `,
  labelContainer: react.css`
    ${styleMixins_reset.boxSizing};
    margin-bottom: 20px;
  `,
  media: (isReversed) => react.css`
    ${styleMixins_reset.boxSizing};
    margin-bottom: 20px;
    width: 100%;

    @media screen and (min-width: 1024px) {
      max-width: 500px;
      margin: ${isReversed ? "0 40px 0 0" : "0 0 0 40px"};
    }
  `,
  heading: react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.pageHeader9}
    color: ${theme_Colors.Colors.GrayWarm10};
    margin-bottom: 20px;
    @media screen and (min-width: 640px) {
      ${theme_LegacyTypography.LegacyTypography.pageHeader7}
    }

    @media screen and (min-width: 1024px) {
      ${theme_LegacyTypography.LegacyTypography.pageHeader5}
    }
  `,
  description: react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.paragraph1Short}
    color: ${theme_Colors.Colors.GrayWarm10};
    margin-bottom: 20px;
  `,
  cta: react.css`
    ${styleMixins_reset.boxSizing};
    & > a,
    & > button {
      width: 100%;
    }

    @media screen and (min-width: 640px) {
      & > a,
      & > button {
        width: auto;
      }
    }
  `,
  secondaryCta: react.css`
    ${styleMixins_reset.boxSizing};
    margin-top: 20px;
  `
});
const TwoColumnRiver = ({ backgroundColor = "neutral100", ctaColor = "primary", ctaHref, ctaText, ctaTarget, description, heading, isReversed = false, media, onCtaClick, onCtaKeyDown, onSecondaryCtaClick, onSecondaryCtaKeyDown, secondaryCtaHref, secondaryCtaText, label, labelIcon, labelColor, className }) => {
  const getCtaComponent = () => {
    const sharedProps = {
      children: ctaText,
      href: ctaHref,
      onClick: onCtaClick,
      onKeyDown: onCtaKeyDown,
      target: ctaTarget
    };
    return react.jsx(components_navigation_Button_Button.Button, Object.assign({}, sharedProps, {
      // "primary-alt" no longer exists as of V8 and is now mapped to "primary"
      color: ctaColor === "primary-alt" ? "primary" : ctaColor
    }));
  };
  return react.jsx(
    "div",
    { css: Styles.root(backgroundColor), className, "data-zds": true },
    react.jsx(
      "div",
      { css: Styles.container(isReversed), className: "twoColumnRiver-container", "data-zds": true },
      react.jsx(
        "div",
        { css: Styles.content, className: "twoColumnRiver-content", "data-zds": true },
        label && react.jsx(
          "div",
          { css: Styles.labelContainer, className: "twoColumnRiver-labelContainer", "data-zds": true },
          react.jsx(components_display_Tag_Tag.Tag, { variant: labelColor }, labelIcon ? react.jsx(
            components_layout_Grid_Grid.Grid,
            { alignItems: "center", columns: "auto max-content", gap: 5 },
            react.jsx(components_display_Icon_Icon.Icon, { name: labelIcon, size: 20 }),
            label
          ) : label)
        ),
        react.jsx(
          components_display_Heading_HeadingLevel.HeadingLevel,
          null,
          react.jsx(components_display_Heading_Heading.Heading, { css: Styles.heading }, heading)
        ),
        description && react.jsx("div", { css: Styles.description, className: "twoColumnRiver-description", "data-zds": true }, description),
        ctaText && (ctaHref || onCtaClick) && react.jsx("div", { css: Styles.cta, className: "twoColumnRiver-cta", "data-zds": true }, getCtaComponent()),
        secondaryCtaText && secondaryCtaHref && react.jsx(
          "div",
          { css: Styles.secondaryCta, className: "twoColumnRiver-secondaryCta", "data-zds": true },
          react.jsx(components_navigation_Link_Link.Link, { href: secondaryCtaHref, onClick: onSecondaryCtaClick, onKeyDown: onSecondaryCtaKeyDown, weight: "bold" }, secondaryCtaText)
        )
      ),
      media && react.jsx("div", { css: Styles.media(isReversed), className: "twoColumnRiver-media", "data-zds": true }, media)
    )
  );
};

exports.TwoColumnRiver = TwoColumnRiver;
//# sourceMappingURL=TwoColumnRiver.cjs.js.map
